<template>
    <div class="MobileMenuBlock">
        <div class="MobileMenuBlock-item">
            <div
                v-show="!withSubMenu"
                class="MobileMenuBlock-link"
            >
                <a
                    href="#"
                    @click="followLink($event, link)"
                >{{ link.label }}</a>
            </div>

            <div
                v-show="withSubMenu"
                class="MobileMenuBlock-title"
                @click="toggleAccount"
                @keyup.enter="toggleAccount"
            >
                <div>{{ label }}</div>
                <span
                    v-show="showAccount"
                    class="MobileMenuBlock-chevronDown f2m-chevron-right"
                />
                <span
                    v-show="!showAccount"
                    class="MobileMenuBlock-chevronRight f2m-chevron-right"
                />
            </div>
            <Transition
                name="fade-slide"
                mode="out-in"
            >
                <ul
                    v-show="showAccount && withSubMenu"
                    class="MobileMenuBlock-list"
                >
                    <li
                        v-for="(menu, index) in subMenu"
                        :key="index"
                        class="MobileMenuBlock-listItem"
                    >
                        <a
                            href="#"
                            @click="followLink($event, menu)"
                        >
                            <span
                                v-if="menu.iconClass"
                                :class="menu.iconClass"
                            />
                            {{ menu.label }}
                        </a>
                    </li>
                </ul>
            </Transition>
        </div>
    </div>
</template>
<script>
import Transition from "@/components/Transition.vue"
export default {
    components: {
        Transition
    },
    props: {
        label: {
            type: String,
            default: () => ('')
        },
        withSubMenu: {
            type: Boolean,
            default: false,
        },
        subMenu: {
            type: Array,
            default: () => ([])
        },
        link: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            showAccount: false
        }
    },
    methods: {
        toggleAccount() {
            this.showAccount = !this.showAccount;
        },
        followLink($event, link) {
            $event.preventDefault();
            if (link.type === "link") {
                window.location.href = `${this.$baseUrl}${link.target}`;
            } else {
                this.$emit('hideMenu');
                this.$router.push({name: link.target});
            }
        }
    }
}

</script>
<style lang="scss">
.MobileMenuBlock {
    margin-top: 14px;
    padding: 16px;
    background: rgba(255,255,255, .1);
    mix-blend-mode: normal;
    border-radius: 10px;
    font-style: normal;
    font-weight: 800;
    font-size: 18px;
    line-height: 22px;
    display: flex;
    align-items: center;
    letter-spacing: 0.3px;

    &-item {
        width: 100%;
    }

    &-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: rgba(255,255,255, 1);
        background: transparent;
    }

    &-chevronDown {
        transform: rotate(90deg);
    }

    &-chevronRight {
        font-size: 16px;
    }

    &-list {
        list-style: none;
        margin-bottom: 0;
        padding-left: 15px
    }

    &-listItem {
        display: flex;
        align-items: center;
        gap: 10px;
        color: white;
        font-size: 18px;
        font-weight: normal;
        padding: 18px 0 9px;
        a {
            width: 100%;
            font-weight: normal;
            color: white;
            &:hover {
                font-weight: bold;
            }
            span {
                margin-right: 10px;
            }
        }
    }

    &-link {
        a {
            font-weight: normal;
            color: white;
            &:hover {
                font-weight: bold;
            }
        }
    }
}
</style>
